import React from "react";
import { Input, InputProps } from "semantic-ui-react";

const InputWrapper = (props: InputProps) => {
  return <Input {...props} />;
};

export default InputWrapper;
